import { ThemeProvider, createTheme } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { ptBR } from '@mui/x-date-pickers/locales';
import { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import * as React from 'react';

type CalendarType = DatePickerProps<Dayjs> & { color?: string };

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF7020',
    },
  },
});

const CalendarMui = (props: CalendarType) => {
  const { color } = props;
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
      adapterLocale="pt-br"
    >
      <ThemeProvider theme={theme}>
        <DatePicker
          views={['day', 'month', 'year']}
          format="DD/MM/YYYY"
          {...props}
          slotProps={{
            popper: {
              sx: {
                '& .Mui-selected': {
                  backgroundColor: '#333 !important',
                  color: '#fff !important',
                  outline: 'none !important',
                },
                button: {
                  borderRadius: 2,
                  outline: 'none !important',
                },
                'button:focus': {
                  background: '#333  !important',
                  color: '#fff !important',
                },
                'button:hover': {
                  background: '#ddd !important',
                },
              },
            },
            textField: {
              onKeyDown: (e) => {
                e.preventDefault();
              },
              sx: {
                '& input': { color },
                '& .MuiOutlinedInput-root': {
                  '& .Mui-focused fieldset': {
                    borderColor: '#FF7020',
                  },
                },
              },
            },
          }}
        />
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default CalendarMui;
